import axios from 'axios'

// 获取当前的配置
let ACTIVE_ENV_CONFIG = process.env.ACTIVE_ENV_CONFIG
// console.log(ACTIVE_ENV_CONFIG);

// 获取配置环境的公共参数值
let envParams = process.env[ACTIVE_ENV_CONFIG]
// console.log('envParams:' + JSON.stringify(envParams))  

// 创建一个拥有通用配置的axios实例,实例中的配置内容根据实际开发需求而定
export const apiService = axios.create({
  // http://47.103.210.35:8093
  // 'http://test-oms.sinoslogistics.com/'
  baseURL: 'https://oms.sinoslogistics.com/',
  timeout: 1000 * 10, // 请求超时的毫秒数,如果请求花费超过timeout的时间,请求将被中断
  withCredentials: true, // 表示跨域请求时是否需要使用凭证,默认false
  // headers: { 'Content-Type': 'Access-Control-Allow-Credentials','Authorization':'Bearer tokenStr' } // 'Cache-Control': 'no-cache'不允许缓存，需要重新获取请求 //    'Content-Type': 'application/x-www-form-urlencoded'使post请求发送的是FormData格式数据
})

// 添加请求拦截器
apiService.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error)
})

/*
 *get方法，对应get请求
 *@param {String} url [请求的url地址]
 *@param {Object} params [请求时候携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/*
 *post方法，对应post请求
 *@param {String} url [请求的url地址]
 *@param {Object} params [请求时候携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}


// WEBPACK FOOTER //
// ./src/request.js